import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/index.json';
import es from './locales/es/index.json';
import fr from './locales/fr/index.json';
import de from './locales/de/index.json';
import ar from './locales/ar/index.json';
import zh from './locales/zh/index.json';
import ja from './locales/ja/index.json';
import pt from './locales/pt/index.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
      ar: { translation: ar },
      zh: { translation: zh },
      ja: { translation: ja },
      pt: { translation: pt }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
